<table class="subwindow" [cdkDragConstrainPosition]="constrainPosition" plessTitleWindowSub cdkDrag [windowMovable]="false" [windowResizable]="false"
  [frontDispFlag]="true">
  <tr class="subwindow-title" cdkDragHandle>
    <th class="window-title-name">商品仕様取込</th>
    <!-- ダイアログ閉じるボタンを最後にフォーカスしたいため最後方に移動済 -->
  </tr>
  <tr class="subwindow-body" [style.background-color]="this.model.backgroundColor">
    <td>
      <!-- ダイアログ表示コンテンツメイン -->
      <div class="contents-area" (dragstart)="onDragstartBody($event)">

        <!-- 表示メッセージ -->
        <label>
          新規登録商品が {{ input.newGoodsNum }} 件ありました。<br>
          更新商品が {{ input.updateSingleGoodsNum + input.selectableGoodsNum }} 件ありました。<br>
          更新商品の中で取込先候補が複数件存在する商品が {{ input.selectableGoodsNum }} 件ありました。<br>
          取込先候補が複数件存在する商品 {{ input.selectableGoodsNum }} 件に対して、商品を選択してください。
        </label>

        <div>
          <h1>eBASE取込データ</h1>
          <div>
            <div class="action-area">
              <app-custom-pager
                [prevDisabled]="model.currentIndex <= 0"
                [nextDisabled]="model.currentIndex >= input.selectableEBaseGoodsList.length - 1"
                [display]="pagerDisplayLabel()"
                (prevHandler)="eventPrevButton_CLICKHandler()"
                (nextHandler)="eventNextButton_CLICKHandler()"
              >
              </app-custom-pager>
            </div>
            <!-- データグリッド定義 eBASE取込データ -->
            <wj-flex-grid #dtg_CurrentSelectableEBaseGoodsInfo id="dtg_CurrentSelectableEBaseGoodsInfo"
              [itemsSource]="[model.currentSelectableEBaseGoodsInfo]" [tabindex]="0" [selectionMode]="'Row'"
              [headersVisibility]="'Column'" [isReadOnly]="true" [allowDragging]="'None'" [allowSorting]="false">
              <wj-flex-grid-column [minWidth]="5" [width]="280" [isReadOnly]="true" [header]="'eBASE仕様書NO'" [binding]="'eBaseSpecCode'"></wj-flex-grid-column>
              <wj-flex-grid-column [minWidth]="5" [width]="150" [isReadOnly]="true" [header]="'JANコード'" [binding]="'janCode'"></wj-flex-grid-column>
              <wj-flex-grid-column [minWidth]="5" [width]="200" [isReadOnly]="true" [header]="'商品名'" [binding]="'goodsName'"></wj-flex-grid-column>
              <wj-flex-grid-column [minWidth]="5" [width]="200" [isReadOnly]="true" [header]="'規格名'" [binding]="'standardName'"></wj-flex-grid-column>
              <wj-flex-grid-column [minWidth]="5" [width]="70" [isReadOnly]="true" [header]="'入数'" [binding]="'containNum'" [align]="'right'"></wj-flex-grid-column>
              <wj-flex-grid-column [minWidth]="5" [width]="380" [isReadOnly]="true" [header]="'メーカー名'" [binding]="'makerName'"></wj-flex-grid-column>
            </wj-flex-grid>
          </div>
        </div>

        <div>
          <h1>取込先商品候補一覧</h1>
          <div>
            <!-- データグリッド定義 eBASE 取込商品候補一覧 -->
            <wj-flex-grid #dtg_CurrentCandidateGoodsInfoList id="dtg_CurrentCandidateGoodsInfoList"
              [itemsSource]="model.currentCandidateGoodsInfoList" [tabindex]="0" [frozenColumns]="2" [selectionMode]="'Row'"
              [headersVisibility]="'Column'" [isReadOnly]="false" [allowDragging]="'None'" [allowSorting]="false">
              <wj-flex-grid-column [minWidth]="5" [width]="40" [header]="' '" [binding]="'checked'" [align]="'center'" [isReadOnly]="true">
                <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                  <input type="checkbox" id="cb_goods_info_{{cell.row.index}}" [(ngModel)]="cell.item.checked"
                    (change)="eventCheckbox_CLICKHandler()" (mouseup)="$event.stopPropagation()">
                </ng-template>
              </wj-flex-grid-column>
              <wj-flex-grid-column [minWidth]="5" [width]="120" [isReadOnly]="true" [header]="'Pコード'" [binding]="'pCode'"></wj-flex-grid-column>
              <wj-flex-grid-column [minWidth]="5" [width]="120" [isReadOnly]="true" [header]="'アイテムコード'" [binding]="'itemCode'"></wj-flex-grid-column>
              <wj-flex-grid-column [minWidth]="5" [width]="150" [isReadOnly]="true" [header]="'JANコード'" [binding]="'janCode'"></wj-flex-grid-column>
              <wj-flex-grid-column [minWidth]="5" [width]="205" [isReadOnly]="true" [header]="'商品名'" [binding]="'goodsName'"></wj-flex-grid-column>
              <wj-flex-grid-column [minWidth]="5" [width]="205" [isReadOnly]="true" [header]="'規格名'" [binding]="'standardName'"></wj-flex-grid-column>
              <wj-flex-grid-column [minWidth]="5" [width]="70" [isReadOnly]="true" [header]="'入数'" [binding]="'containNum'" [align]="'right'"></wj-flex-grid-column>
              <wj-flex-grid-column [minWidth]="5" [width]="250" [isReadOnly]="true" [header]="'仕様書コード'" [binding]="'eBaseSpecCode'"></wj-flex-grid-column>
              <wj-flex-grid-column [minWidth]="5" [width]="120" [isReadOnly]="true" [header]="'最終更新日'" [binding]="'updateDate'"></wj-flex-grid-column>
            </wj-flex-grid>
          </div>
        </div>
      
      </div>
    </td>
  </tr>

  <tfoot cdkDragHandle>
    <tr>
      <td>
        <div class="footer-buttons">
          <button forcedEnabledMode="true" class="btn-primary" [tabindex]="0" (click)="eventImport_CLICKHandler()" [disabled]="model.isDesabledImportButton">
            取込
          </button>
        </div>
        <div class="window-title-close">
          <!-- ダイアログ閉じるボタンを最後にフォーカスしたいため最後方に移動済 -->
          <button [tabindex]="0" (click)="eventClose_CLICKHandler()"></button>
        </div>
      </td>
    </tr>
  </tfoot>
</table>
